/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating types of organizations.
 */
export enum HousingOrgTypes {
    HMB = 'HMB',
    AGENCY = 'Agency',
    OTHER = 'Other',
}
